module.exports = __webpack_public_path__ + "img/photo-16.c6ccf8ad.webp";